import { PlannedLessonMessage } from '../../boutique-classroom.types';

export const PLANNED_LESSON_MAX_STUDENTS = 3;
export const PLANNED_LESSON_DEFAULT_DAY_RANGE = 28;
export const PLANNED_LESSON_DATE_PARAM_FORMAT = 'YYYY-MM-DD';
export const PLANNED_LESSON_DATE_TIME_PARAM_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const PLANNED_LESSON_SHORT_DATE_FORMAT = 'D MMM YYYY';
export const PLANNED_LESSON_LONG_DATE_FORMAT = 'DD.MM.YYYY';
export const PLANNED_LESSON_WEEKDAY_FORMAT = 'dddd';
export const PLANNED_LESSON_MONTH_FORMAT = 'MMMM YYYY';
export const PLANNED_LESSON_TIME_LENGTH = 5;

export const PlannedLessonStep = {
	STUDENTS: 1,
	DETAILS: 2,
	SUMMARY: 3,
	SUCCESS: 4
} as const;

export const PLANNED_LESSON_STEPS = [
	{ id: PlannedLessonStep.STUDENTS, label: 'Öğrenciler' },
	{ id: PlannedLessonStep.DETAILS, label: 'Ders, Uzman, Tarih' },
	{ id: PlannedLessonStep.SUMMARY, label: 'Özet ve Onay' }
] as const;

export const PLANNED_LESSON_TEXT = {
	OPEN_BUTTON: 'Planlı Özel Ders Oluştur',
	MAX_STUDENTS_HINT: `En fazla ${PLANNED_LESSON_MAX_STUDENTS} öğrenci seçebilirsiniz`,
	TITLE: 'Planlı Özel Ders Oluştur',
	DESCRIPTION: 'Seçili öğrenciler için planlı özel ders oluşturun.',
	SELECTED_STUDENTS: 'Seçilen Öğrenciler',
	STUDENTS_INFO: 'Her öğrenci için ayrı ders, uzman ve tarih/saat seçebilirsiniz. Oluşturulan dersler birbirinden bağımsız randevular olarak kaydedilecektir.',
	DETAILS_DESCRIPTION: 'Her öğrenci için bilgileri ayrı ayrı seçin.',
	BRANCH_LABEL: 'Branş',
	LESSON_LABEL: 'Ders',
	UNIT_LABEL: 'Ünite',
	TOPIC_LABEL: 'Konu',
	EXPERT_LABEL: 'Uzman',
	DATE_TIME_LABEL: 'Tarih & Saat',
	DATE_TIME_PLACEHOLDER: 'Tarih & Saat Seç',
	SELECT_PLACEHOLDER: 'Seçiniz',
	SUMMARY_TITLE: 'Oluşturulacak Dersler',
	CANCEL: 'İptal',
	BACK: 'Geri',
	CONTINUE: 'Devam Et',
	CREATE_SUFFIX: 'Dersi Oluştur',
	CREATING: 'Oluşturuluyor...',
	MINUTES_SUFFIX: 'dakika',
	SUCCESS_TITLE: 'Dersler başarıyla planlandı!',
	SUCCESS_DESCRIPTION_SUFFIX: 'öğrencinin planlı özel dersi oluşturuldu.',
	PLAN_ANOTHER: 'Başka Ders Planla',
	DONE: 'Tamam',
	DATE_MODAL_TITLE: 'Tarih & Saat Seç',
	START_TIME_LABEL: 'Başlangıç Saati',
	SELECT: 'Seç',
	SLOTS_LOADING: 'Uygun saatler yükleniyor...',
	NO_SLOTS_FOR_DAY: 'Bu gün için uygun saat bulunmuyor.',
	PICK_DAY_FIRST: 'Uygun saatleri görmek için bir gün seçin.',
	TOGGLE_DETAILS: 'Detayları göster/gizle',
	PREV_MONTH: 'Önceki ay',
	NEXT_MONTH: 'Sonraki ay'
} as const;

export const PLANNED_LESSON_ERROR = {
	STUDENT_CONFLICT: {
		title: 'Randevu çakışması var',
		message: 'Bu öğrenci için aynı gün aynı dersten başka bir randevu bulunuyor. Farklı bir gün seçerek devam edebilirsin.'
	},
	EXPERT_CONFLICT: (name: string): PlannedLessonMessage => ({
		title: 'Uzman bu saatte uygun değil',
		message: `${name} adlı uzmanın bu tarih ve saatte başka bir randevusu bulunuyor. Lütfen farklı bir tarih veya saat seçin.`
	}),
	CREATE_FAILED: (name: string, reason?: string): PlannedLessonMessage => ({
		title: 'Ders oluşturulamadı',
		message: reason || `${name} adlı öğrenci için ders oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.`
	})
} as const;

export const PLANNED_LESSON_WEEKDAY_SHORT: Record<string, string> = {
	pazartesi: 'Pzt',
	salı: 'Sal',
	çarşamba: 'Çar',
	perşembe: 'Per',
	cuma: 'Cum',
	cumartesi: 'Cmt',
	pazar: 'Paz'
};

export const PLANNED_LESSON_DIALOG_CONFIRM = 'Tamam';

export const PLANNED_LESSON_BLOCKER = {
	TITLE: 'Planlı özel ders oluşturulamıyor',
	DESCRIPTION: 'Seçtiğin öğrenciler için aşağıdaki sorunlar tespit edildi.',
	FOOTNOTE: 'Sorunlar giderildikten sonra tekrar deneyebilirsin.',
	NOT_IN_GROUP: 'Herhangi bir gruba atanmadı.',
	NO_ACADEMIC_BOARD: 'Bağlı olduğu grup için Akademik Kurul tanımlanmamış.',
	NO_BOARD_EXPERT: 'Planlı özel ders eğitmeni atanmamış.'
} as const;
